import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCompassPointer: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="compass-pointer, arrow, route"><path d="M4.25 19.75L12 3.5L19.75 19.75L12 17L4.25 19.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCompassPointer;
